import headerBg from "@/assets/images/active/sakura/sanliouLinkage/header/bg.png";
import headerBg2 from "@/assets/images/active/sakura/sanliouLinkage/header/bg_notlogin.png";
import officeBtn from "@/assets/images/active/sakura/sanliouLinkage/header/offical.png";
import loginBtn from "@/assets/images/active/sakura/sanliouLinkage/header/login.png";
import accountBtn from "@/assets/images/active/sakura/sanliouLinkage/header/login.png";
import activeBtn from "@/assets/images/active/sakura/sanliouLinkage/header/login.png";
import logoutBtn from "@/assets/images/active/sakura/sanliouLinkage/header/loginout.png";

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: "",
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: "#f9607f",
    sub_title_color: "#f9607f",
    tips_color: "#f9607f",
    height: "",
    game_name: "魔卡少女樱：回忆钥匙",
  },
  operation_btn: {
    office_website: {
      width: "",
      height: "",
      background_image: "",
      img: officeBtn,
      style: "top: 0.2rem;",
      link: "https://sakura.qingcijoy.com/",
    },
    login: {
      width: "",
      height: "",
      background_image: "",
      img: loginBtn,
      style: "top: 0.2rem",
    },
    change_account: {
      width: "",
      height: "",
      background_image: "",
      img: accountBtn,
      style: "top: 0.2rem",
    },
    join_active: {
      width: "",
      height: "",
      background_image: "",
      img: activeBtn,
      style: "top: 0.2rem",
      link: "https://qcg.ink/XrLOO4",
    },
    logout: {
      width: "",
      height: "",
      img: logoutBtn,
      style: "top: 0.2rem",
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/sakura/sanliouLinkage/headerConfig.js